import { Virtuoso } from "react-virtuoso";
import localize from "src/l10n/localize";
import { MediumBodyBolder } from "src/components/Text";
import { GroupedTableFlatRow } from "../GroupedTableFlatRow";
import { useGroupedTableInternal } from "../utils";

function GroupedTableViewport<TRow>(): JSX.Element {
    const { flatItems, slots } = useGroupedTableInternal<TRow>();

    if (flatItems.length === 0) {
        if (typeof slots?.EmptyState === "function") {
            return (
                <div className="GroupedTableList">
                    {slots.EmptyState()}
                </div>
            );
        }

        if (slots?.EmptyState) {
            return (
                <div className="GroupedTableList">
                    {slots.EmptyState}
                </div>
            );
        }

        return (
            <div className="GroupedTableList">
                <div className="GroupedTableList-empty">
                    <MediumBodyBolder color="contentNormal">
                        {localize("ORG_PAGE_NO_CONTENT")}
                    </MediumBodyBolder>
                </div>
            </div>
        );
    }

    return (
        <Virtuoso
            className="GroupedTableList"
            computeItemKey={(index, item) => `${item.key}|${index}`}
            data={flatItems}
            increaseViewportBy={{ top: 400, bottom: 800 }}
            itemContent={(_, item) => (
                <GroupedTableFlatRow<TRow> item={item} />
            )}
            overscan={400}
            useWindowScroll
        />
    );
}

export default GroupedTableViewport;
